import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Dosis Obat Akurat";
const DESCRIPTION =
  "Kalkulator dosis obat akurat: Tentukan jumlah harian obat yang aman (mg/kg) berdasarkan berat badan dan usia! Alat yang diandalkan untuk dokter dan apoteker dengan penjelasan tentang dosis maksimum dan potensi interaksi obat.";
const KEYWORDS = "dosis, kalkulator dosis, obat, berat badan pasien";
const OG_URL =
  "https://do-calculate.com/calculator/id/medicine-dosage-calculator/";
function DosageCalculator() {
  const [totalDosage, setTotalDosage] = useState("");
  const [singleDosage, setSingleDosage] = useState("");
  const [weight, setWeight] = useState("");
  const [frequency, setFrequency] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (weight && totalDosage) {
        let totalDose = parseInt(weight) * parseInt(totalDosage);
        let singleDose = totalDose;
        if (frequency === "Dua kali sehari") {
          singleDose = totalDose / 2;
        } else if (frequency === "Tiga kali sehari") {
          singleDose = totalDose / 3;
        } else if (frequency === "Empat kali sehari") {
          singleDose = totalDose / 4;
        } else if (frequency === "Setiap 4 jam") {
          singleDose = totalDose / 6;
        }
        setResult({
          totalDose,
          singleDose: frequency !== "Satu kali sehari" ? singleDose : null,
        });
      }
    } catch (error) {
      setError(error.message);
    }
  };
  const handleFrequencyChange = (selectedFrequency) => {
    setFrequency(selectedFrequency);
    setSingleDosage(selectedFrequency !== "Satu kali sehari");
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Kalkulator dosis pintar dan akurat yang dirancang khusus untuk menyederhanakan proses perhitungan dosis obat. Dengan antarmuka yang intuitif, Anda dapat dengan mudah memasukkan berat badan pasien dan dosis yang diresepkan untuk mendapatkan jadwal dosis harian yang terperinci. Kalkulator ini didasarkan pada standar medis terbaru untuk memastikan akurasi hasil, memberikan Anda ketenangan pikiran dan keyakinan dalam keputusan yang Anda buat. Baik Anda seorang dokter, apoteker, atau wali, kalkulator ini adalah alat yang sempurna untuk membantu Anda mengelola dosis obat secara efektif.
                </p>
                <p>Untuk menghitung dosis harian, Anda dapat mengikuti langkah-langkah berikut:</p>
                <ul>
                  <li>Masukkan berat badan pasien</li>
                  <li>Masukkan dosis tunggal dalam miligram</li>
                  <li>Pilih jumlah dosis per hari</li>
                </ul>
                <p>
                  {" "}
                  Kalkulator ini dikembangkan berdasarkan{" "}
                  <a
                    href="https://lo.unisa.edu.au/pluginfile.php/1902200/mod_resource/content/6/Maths%20for%20Midwifery%20and%20Nursing%20Dosage%20Calculation%20-%20Worksheet_2022.pdf"
                    rel="nofollow"
                  >
                    perhitungan dosis dari University of South Australia - Lembar Kerja
                  </a>
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div >
                  <div>
                    <hr />
                    <div className="form-group" htmlFor="weight">
                      <label className="form-label ms-2">Masukkan berat badan (kg)</label>
                      <input
                        id="weight"
                        type="number"
                        value={weight}
                        onChange={(e) => setWeight(e.target.value)}
                        placeholder="Masukkan berat badan"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group" htmlFor="dosage">
                      <label className="form-label ms-2">
                        Masukkan dosis (mg)
                      </label>
                      <input
                        id="dosage"
                        type="number"
                        value={totalDosage}
                        onChange={(e) => setTotalDosage(e.target.value)}
                        placeholder="Masukkan dosis"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group items-center">
                      <label className="form-label ms-2" htmlFor="frequency">
                        Pilih dosis harian
                      </label>
                      <select
                        id="frequency"
                        value={frequency}
                        onChange={(e) => handleFrequencyChange(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="">Pilih dosis harian</option>
                        <option value="Satu kali sehari">Satu kali sehari</option>
                        <option value="Dua kali sehari">Dua kali sehari</option>
                        <option value="Tiga kali sehari">Tiga kali sehari</option>
                        <option value="Empat kali sehari">Empat kali sehari</option>
                        <option value="Setiap 4 jam">Setiap 4 jam</option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                      disabled={frequency === ""}
                    >
                      Hitung
                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Kesalahan: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Hasil:</h4>
                      <p className="text-white">
                        Dosis harian: {result.totalDose} mg
                      </p>
                      {result.singleDose && (
                        <p className="text-white">
                          Dosis tunggal: {result.singleDose} mg
                        </p>
                      )}
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Apa itu dosis harian?</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Definisi Dosis Harian</h2>{" "}
                  </u>
                  <p>
                    Dosis harian adalah jumlah obat yang perlu dikonsumsi pasien selama satu hari.
                  </p>
                  <p>
                    Dosis harian bervariasi berdasarkan berat badan, usia, dan kondisi kesehatan pasien.
                  </p>
                  <div className="p-3 mb-2 bg-info">
                    Menentukan dosis yang tepat sangat penting untuk memastikan efektivitas pengobatan.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Bagaimana dosis dihitung?</h2>{" "}
                  </u>
                  <p>
                    Dosis dihitung menggunakan rumus medis berdasarkan berat badan pasien dan konsentrasi obat.
                  </p>
                  <ul>
                    <li>Rumus dosis tunggal: Berat badan pasien × konsentrasi obat</li>
                    <li>Rumus dosis harian: Dosis tunggal × jumlah dosis</li>
                  </ul>
                  <p>
                    Anda dapat menggunakan kalkulator ini untuk menentukan dosis harian berdasarkan berat badan, konsentrasi, dan frekuensi dosis.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    Pastikan selalu mengikuti petunjuk dokter atau apoteker.
                  </div>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Contoh Ilustratif</h2>{" "}
                  </u>
                  <p>Misalkan Anda perlu menghitung dosis harian untuk obat tertentu:</p>
                  <ul>
                    <li>Berat badan pasien: 70 kg</li>
                    <li>Dosis obat: 10 mg</li>
                    <li>Frekuensi dosis harian: Dua kali</li>
                  </ul>
                  <p>Dosis harian: 70 kg × 10 mg = 700 mg</p>
                  <p>Dosis tunggal: 700 mg / 2 = 350 mg</p>
                  <b>Contoh</b>
                  <div className="p-3 mb-2 bg-info text-black">
                    Dalam contoh ini, dosis tunggal adalah 350 mg.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default DosageCalculator;